import Common from '@/utils/axios';
import CryptoJS from 'crypto-js';
// import common from '@/utils/common';
// import qs from 'query-string';
import { checkDomain } from '@/utils/utils';
import * as Type from './interface';

const { REACT_APP_IMURL, REACT_APP_PANURL, REACT_APP_PANURL_BACKUP } = process.env;
const APP_APIPANURL = async () => (await checkDomain(REACT_APP_PANURL) ? REACT_APP_PANURL : REACT_APP_PANURL_BACKUP);
export { Type };
export const getKnoList = (params: Type.INoteListParams) => Common.get<Type.INoteListRes>('/api/video/note/list', params);
export const getQuizList = (params: any) => Common.get('/api/classroom/quiz/list', params);
export const addKnoPoint = (data: Type.IAddKnoPointParams) => Common.post<Type.IAddKnoPointRes>('/api/video/note/add', data);
export const editKnowPoint = (data: any) => Common.post('/api/video/note/edit', data);

export const publishKnoPoint = (params: Type.PublishKnoPointParams) => Common.post<any>('/api/video/note/publish', params);
export const delKnoPoint = (params: Type.IDelMarkParams) => Common.post<any>('/api/video/note/delete', params);
export const getKnoPointShareUrl = (params: Type.IGetKnoPointShareUrlParams) => Common.get<any>('/api/video/note/share-url', params);
export const getRecordDetail = (params: any) => Common.get('/api/video/record/detail', params);
export const onStarReward = (params: any) => Common.post('/api/video/star/add', params);
// 获取回放是否过期、是否已奖励、星星回放任务规则、AI相关配置
export const getReplayInfo = (params: Type.ReplayConfigParams) => Common.get<Type.ReplayConfigRes>('/api/video/config', params);
export const getChatRecordList = (params: Type.IChatRecordParams) => Common.get<Type.IChatRecordRes>('/api/chat-record/list', params);
export const getShareUrl = (params: any) => Common.get('/api/video/note/share-url', params);
export const getClassroom = (params: any) => Common.get('/api/client/module/info', {
  queryLiveStreamUrl: true,
  checkBlacklist: false,
  ...params,
}); // queryLiveStreamUrl和checkBlacklist为固定参数
export const getBoardsinfo = (params: any) => Common.post('/api/client/h5/config/pandora/boards', params);
export const getMediaInfo = (classroomId: any) => Common.get(`/api/client/media/${classroomId}/info`);
// 获取长期有效token
export const getEffectiveToken = (token: any) => Common.get(`/api/login/fetchToken/${token}`);
// 获取讲义下载地址
export const getHandoutInfo = (params: any) => Common.get('/api/video/zx-lecture', params);
export const getExternalQuestion = (params: any) => Common.get('/api/client/external-question/info', params);
// 获取答题卡
export const submitAnswerSheet = (params: any) => Common.get('/quiz/api/v1/quiz/submit', params);
// 获取oss上传文件签名（打标记点时使用）
export const getSignedUrl = (params: Type.ISignedUrlParams) => Common.get<Type.ISignedUrlRes>('/api/upload/oss/signed-url', params);
// 判断是否为游客
export const getIsTour = (params: Type.IsTourParams) => Common.get<Type.IsTourRes>('/api/client/module/info/playback', params);
// 分享获取信息
// 回访数据上报接口（目前仅在线）
export const reportPlayBack = (params: any) => Common.post('/api/video/report-playback', params);
export const getShareInfo = (params: Type.ShareInfoParams) => Common.get<Type.ShareInfoRes>('/api/video/note/share-info', params);
// 开启/关闭AI功能
export const toggleRecap = (params: Type.RecapToggleParams) => Common.post('/api/video/ai-entry/authorize', params);
// 获取高光时刻视频
export const getHighLightVideo = (params: Type.GetHighLightVideoParams) => Common.get<Type.GetHighLightVideoRes>('/api/classroom/highlight/video', params);

// 反馈接口
export const feedbackRecap = (
  params: Type.RecapFeedbackParams,
  Uid: string | number,
  userToken: string,
) => Common.post<Type.RecapFeedbackRes>('/v1/feedback/submit', params, {
  baseURL: REACT_APP_IMURL,
  headers: { Uid, Authorization: `Bearer ${userToken}` },
});
export const reportPlayBackSync = (params: any) => Common.sendBeacon(
  '/api/video/report-playback',
  new Blob([JSON.stringify(params)], { type: 'application/json' }),
);
// 云盘获取视频URL
export const yunpanPreview = async (
  unids: string,
  token: string,
) => {
  const baseURL = await APP_APIPANURL();
  return Common.get<any>('api/inode/bulk', { unids }, {
    baseURL,
    headers: { 'x-roombox-token': token },
  });
};
// 云盘预览获取互动题
export const yunpanBc = async (
  unids: string,
  token: string,
) => {
  const baseURL = await APP_APIPANURL();
  return Common.get<any>(`api/inode/${unids}/bc/events`, {}, {
    baseURL,
    headers: { 'x-roombox-token': token },
  });
};

// 截图
export const sendApp = (agreement: string, jsonStr: string) => {
  console.log(agreement, jsonStr, 'sendApp');
  if (window.Sac_jsCallC) {
    window.Sac_jsCallC(agreement, jsonStr);
  } else {
    const obj: any = {};
    obj[agreement] = jsonStr;
    window.webkit?.messageHandlers?.Sac_jsCallC?.postMessage(obj);
  }
};
export const closeWindow = (agreement: string, jsonStr: string) => {
  console.log(agreement, jsonStr, 'closeWindow');
  if (window.Sac_jsCallC) {
    window.Sac_jsCallC(agreement, jsonStr);
  } else {
    const obj: any = {};
    obj[agreement] = jsonStr;
    window.webkit?.messageHandlers?.Sac_jsCallC?.postMessage(obj);
  }
};

export const getSignedUrls = async (cid: number, uid: number) => {
  const hash = CryptoJS.MD5(`${uid}${(new Date()).getTime()}`);
  const path = `${cid}/${hash}.jpg`;
  const contentType = 'image/jpeg';
  return getSignedUrl({ type: 7, path, contentType });
};

export const uploadSnapShot = async (
  signedUrl: string,
  file: Blob,
) => {
  const url = signedUrl;
  // TODO: 尚未修复，后续解决
  // if (common.isQQ()) {
  //   // qq内置浏览器会自动解码url中的请求参数，此处手动二次编码signature保证参数正确
  //   const [base, query] = url.split('?');
  //   const params: any = qs.parse(query);
  //   params.Signature = encodeURIComponent(params.Signature);
  //   url = `${base}?${qs.stringify(params)}`;
  // }
  return Common.put(url, file, {
    headers: {
      'Content-Type': 'image/jpeg',
    },
  });
};
